import { createStorageBase } from '@/core/utils/localStorage';
export const appSessionStorage = createStorageBase('session');
